import { parsePhoneNumber, isValidPhoneNumber, isPossibleNumber } from 'libphonenumber-js';

export const checkIfValidatePhone = (updatedPhoneNumber: string, originalPhoneNumber: string) => {
  if (!updatedPhoneNumber.length) {
    return false;
  }

  if (isValidPhoneNumber(originalPhoneNumber) && !isPossibleNumber(updatedPhoneNumber)) {
    const parsedPhoneNumber = parsePhoneNumber(originalPhoneNumber);
    return parsedPhoneNumber.countryCallingCode !== updatedPhoneNumber.substring(1);
  }
  return true;
};

export const validatePhone = (phoneNumber: string) => {
  if (!isPossibleNumber(phoneNumber)) {
    return Promise.reject('Incorrect format');
  }
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

  if (
    parsedPhoneNumber.number === phoneNumber &&
    isValidPhoneNumber(parsedPhoneNumber.number, parsedPhoneNumber.country)
  ) {
    return Promise.resolve();
  }
  return Promise.reject('Incorrect format');
};
